export const SECTION_TYPES: { [section: string]: number } = {
  index: 1,
  sale: 2,
  rent: 3,
  'daily-rent': 4,
  commercial: 5,
  'new-buildings': 6,
};
